<div
  class="card-container bg-white model-card-container d-flex flex-column h-100"
>
  <div class="model-card">
    <div class="fw-500 text-base model-heading">
      {{ modelItem?.name || "Model Name" }}
    </div>
    <div class="secondary-color text-s description">
      {{ modelItem?.shortDescription }}
    </div>
  </div>

  <div class="mt-auto">
    <div class="px-3 pb-3">
      <div class="d-flex align-items-center gap-2 chip_overflow pb-3">
        <div class="flex-shrink-0" *ngFor="let chip of modelItem?.tags">
          <ng-container *ngIf="chip?.tag">
            <app-card-chips>{{ chip.tag }}</app-card-chips>
          </ng-container>
        </div>
      </div>

      <!-- Owner Details (Commented out in original) -->
      <!-- 
      <div class="my-3">
        <app-card-owner-detail>
          <span>{{ modelItem.currentOwner?.name || 'Username' }}</span>
          <img
            class="rounded-circle"
            imagePlaceholder
            ngProjectAs="[profileImage]"
            width="24"
            height="24"
            imageFallBack="images/fallback-avatar.png"
            [src]="modelItem.currentOwner?.profilepic"
            [alt]="modelItem.currentOwner?.name || 'Username'"
            [title]="modelItem.currentOwner?.name || 'Username'"
          />
        </app-card-owner-detail>
      </div>
      -->

      <div class="pb-2">
        <app-card-activities
          [downloadCount]="modelItem?.stats?.downloads"
          [viewCount]="modelItem?.stats?.views"
          [saveFileCount]="modelItem?.stats?.size"
        ></app-card-activities>
      </div>

      <div
        class="secondary-color text-s d-flex justify-content-between align-items-center"
      >
        {{ modelItem?.updatedAt | lastUpdatedDays }}
        <span
          *ngIf="linkedArtefact"
          [innerHTML]="linkArtefactIconGreenSvg | safeHTML"
          class="link_artefact_icon"
          matTooltip="Model used to build or fine tune this model."
        ></span>
      </div>
    </div>

    <hr class="m-0 px-0 text-gray" />
    <div class="org-logo-container">
      <span
        [title]="modelItem?.currentOwner?.organization?.name || '' | uppercase"
      >
        {{ modelItem?.currentOwner?.organization?.name | uppercase }}
      </span>
    </div>

    <hr class="px-0 m-0 text-gray" />
    <div class="m-3 d-flex justify-content-between align-items-center">
      <a
        role="button"
        class="btn-tertiary-bordered btn h-auto px-3 py-2"
        (click)="onViewModelClick(modelItem?.id)"
      >
        View Details
      </a>
    </div>
  </div>
</div>
